import { css } from "styled-components";

export const Shadow = (variant = "light") => css`
  box-shadow: ${({ theme }) =>
      theme.palette[variant === "light" ? "disabled" : variant].main}80
    0px 0px 2px;
`;
